"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapForResult = void 0;
var Result_1 = require("./Result");
/**
 *  Maps a `Result<T, E>` to `Result<U, E>` by applying a _transformer_ function
 *  to an contained `Ok(T)` value, leaving an `Err(E)` value untouched.
 *
 *  This function can be used to compose the results of two functions.
 */
function mapForResult(input, transformer) {
    if (!input.ok) {
        return input;
    }
    var result = transformer(input.val);
    return (0, Result_1.createOk)(result);
}
exports.mapForResult = mapForResult;
